import { combineReducers } from 'redux';
import getGuests from 'store/reducers/guest/get-guests';
import guestTableFilters from 'store/reducers/guest/guest-table-filters';

export default combineReducers({
  getGuests,
  guestTableFilters,
});
